import { FileClient } from "clients/rest";

export type B030051ExcelRequest = Partial<{
  nyukinYmdFrom: string;
  nyukinYmdTo: string;
}>;

export const B030051GetExcel = (props: B030051ExcelRequest) => {
  return FileClient.get("b030051/get/excel", {
    params: props,
  });
};
